import { PropType } from 'vue'
import { useSizeProp } from '@zoryn/hooks'
import type { GridOption } from './grid-option'
import type { GridFooterMethod, GridOptions } from './types'

export const gridProps = {
  size: useSizeProp,
  options: {
    type: Object as PropType<GridOption | GridOptions>,
    default: () => ({}),
  },
  editable: {
    type: Boolean as PropType<boolean>,
    default: undefined,
  },
  dblClickEdit: {
    type: Boolean as PropType<boolean>,
    default: undefined,
  },
  height: [String, Number],
  /**
   * 未传 height 时：
   * - true（默认）：按内容自动计算 viewport 高度（无数据 body 200px，有数据最多 10 行）
   * - false：跟随父容器铺满（需父级有明确高度，如 flex:1 / height:100%）
   */
  autoHeight: {
    type: Boolean,
    default: true,
  },
  border: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: false,
  },
  footerData: Array as PropType<Array<Record<string, unknown>>>,
  footerMethod: Function as PropType<GridFooterMethod>,
}
